module.exports = __webpack_public_path__ + "static/media/profile.0387c6dd.svg";